import React, { Suspense, useEffect, useState } from 'react';
import { isBrowser } from './Browser';
import { LogRocketWrapper } from './LogRocketWrapper';
import log from 'loglevel';
import { ENABLE_LOG_ROCKET_IN_DEVELOPMENT, IS_DEVELOPMENT } from 'api-config.mjs';
import { isBot, isChromeLikeUA, hasNoPluginsAndNoLanguages } from '../utils/isBot';


const shouldCreateLogRocket = () => {
  if (!isBrowser()) {
    // TODO: Is this actually necessary?
    return true;  // Do this to ensure the component gets bundled at build time
  }
  if (IS_DEVELOPMENT) {
    return ENABLE_LOG_ROCKET_IN_DEVELOPMENT;
  }
  const { userAgent } = navigator;
  log.debug(`Got userAgent: ${userAgent}`);

  if (userAgent === "cca-app-tester") {
    log.info("Detected cca-app-tester, skipping LogRocket initialization.");
    return false;
  }

  if (isBot(userAgent)) {
    log.info(`Detected bot user agent, skipping LogRocket initialization: ${userAgent}`);
    return false;
  }

  // JS-level automation signals (catches bots that spoof user agent)
  if (navigator.webdriver === true) {
    log.info("Detected navigator.webdriver, skipping LogRocket initialization.");
    return false;
  }

  // Chrome-like UA without the window.chrome object is a strong headless signal.
  // isChromeLikeUA() excludes known Chromium-derivative browsers (Samsung Internet,
  // Opera, Yandex, UC, Huawei, Xiaomi, Brave, Edge) that would otherwise false-positive.
  if (isChromeLikeUA(userAgent) && typeof window.chrome === 'undefined') {
    log.info("Chrome UA but no window.chrome object, skipping LogRocket initialization.");
    return false;
  }

  if (hasNoPluginsAndNoLanguages()) {
    log.info("No plugins and no languages detected, skipping LogRocket initialization.");
    return false;
  }

  return true;
};

const LogRocketLazyLoader = () => {

  log.debug("LogRocketLazyLoader::render()");

  const [ createLogRocket, setCreateLogRocket ] = useState(false);

  useEffect(() => {
    if (shouldCreateLogRocket()) {
      log.debug("Creating Log Rocket Wrapper Component..");
      setCreateLogRocket(true);
    }
  }, []);

  if (!createLogRocket) {
    return (<></>);
  }

  return (
    <>
      <Suspense fallback={<></>}>
        <LogRocketWrapper />
      </Suspense>
    </>
  );
};

export {
  LogRocketLazyLoader
};
